"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var baseThemeTailwindcss_exports = {};
__export(baseThemeTailwindcss_exports, {
  BaseThemeTailwindCSS: () => BaseThemeTailwindCSS,
  baseThemeTailwindcss: () => baseThemeTailwindcss
});
module.exports = __toCommonJS(baseThemeTailwindcss_exports);
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var screens = {
  xs: "0px",
  // For 400% Zoom, the “small” layout size applies for viewports/breakpoints for screen width of 320px to 679px.
  sm: "320px",
  // For 200% Zoom, the “medium” layout size applies for viewports/breakpoints for screen width of 680px to 1023px.
  md: "680px",
  lg: "1024px",
  xl: "1600px"
};
var atomic = {
  color: {
    // Primitives
    transparent: "#0ff0",
    white: "#fff",
    gray: {
      "010": "#e5e5e5",
      "030": "#b3b3b3",
      "040": "#999",
      "060": "#666",
      "080": "#333",
      "085": "#262626",
      100: "#000"
    },
    beige: {
      "060": "#f2f4ed",
      100: "#ebeee2",
      120: "#dddfca",
      140: "#c4c2ab",
      160: "#9d9880",
      180: "#706c5c"
    },
    slate: {
      "010": "#e9f7fb",
      "040": "#bfe6eb",
      "060": "#abd5d8",
      140: "#649396",
      160: "#407177",
      170: "#355f64",
      180: "#2c4e53"
    },
    olive: {
      "060": "#c7e07d",
      100: "#b7c378",
      140: "#80914b"
    },
    terracotta: {
      "080": "#f1995b",
      100: "#e4844f",
      160: "#9a4619"
    },
    blue: {
      "020": "#bad5e4",
      "060": "#5c9fc6"
    },
    green: {
      "020": "#d6f6e3",
      100: "#018939"
    },
    orange: {
      "010": "#fff1dc",
      "020": "#f7ecc9",
      "040": "#ffd99f",
      "060": "#ea9619",
      100: "#e07000"
    },
    red: {
      "020": "#fae5e1",
      100: "#c42a2a",
      120: "#ad2323",
      140: "#891e1e"
    },
    em: {
      green: {
        "020": "#dbeece",
        "040": "#7ebc52",
        "060": "#1a651a",
        "080": "#1a651a"
      }
    },
    em2: {
      orange: {
        "020": "#fcdecf",
        "040": "#f78b64",
        "060": "#db3e1f",
        "080": "#db3e1f"
      }
    },
    phd: {
      purple: {
        "020": "#e7dbf0",
        "040": "#b798cd",
        "060": "#8359a1",
        "080": "#66328b"
      }
    },
    ww: {
      blue: {
        "020": "#d1ebfa",
        "040": "#7ec7f1",
        "060": "#0a6ea9",
        "080": "#0a6ea9"
      }
    },
    al: {
      blue: {
        "010": "#deebf2",
        "020": "#90c6e0",
        "080": "#008ab8",
        100: "#055771"
      }
    },
    /* Surface */
    surface: {
      border: {
        primary: "#706c5c",
        secondary: "#9d9880"
      },
      bg: {
        primary: "#f2f4ed",
        secondary: "#dddfca",
        canvas: "#fff",
        neutral: {
          "inversed: ": "#000"
        },
        white: {
          "static: ": "#000"
        }
      }
    },
    /* Foreground */
    fg: {
      text: {
        primary: "#000",
        secondary: "#333",
        tertiary: "#666",
        subdued: "#706c5c",
        inversed: "#fff"
      },
      black: {
        "static": "#000"
      },
      white: {
        "static": "#000"
      }
    },
    /* Primary */
    primary: {
      "default": "#407177",
      hover: "#355f64",
      active: "#2c4e53",
      "static": "#407177",
      icon: "#fff"
    },
    /* Secondary */
    Secondary: {
      border: "#706c5c",
      "border-empty-default": "#0ff0",
      bg: {
        "ghost-default": "#0ff0",
        "default": "#fff",
        hover: "#f2f4ed",
        active: "#dddfca"
      },
      icon: "#407177"
    },
    /* Input */
    input: {
      accent: {
        "default": "#407177",
        hover: "#355f64",
        active: "#2c4e53",
        live: {
          "default": "#f1995b",
          hover: "#e4844f",
          active: "#9a4619"
        }
      },
      toggle: {
        icon: "#407177",
        handle: "#000"
      }
    },
    /* Informative */
    informative: {
      bg: "#e9f7fb",
      border: "#407177",
      icon: "#407177"
    },
    /* Positive */
    positive: {
      bg: "#d6f6e3",
      border: "#018939",
      icon: "#018939"
    },
    /* Warning */
    warning: {
      bg: "#f7ecc9",
      border: "#e07000",
      icon: "#e07000"
    },
    /* Negative */
    negative: {
      text: "#c42a2a",
      "text-inversed": "#fff",
      border: "#c42a2a",
      icon: "#c42a2a",
      "icon-inversed": "#fff",
      "icon-static": "#c42a2a",
      bg: {
        "default": "#c42a2a",
        hover: "#ad2323",
        active: "#891e1e",
        "static": "#fae5e1",
        "static-subdued": "#000"
      }
    },
    /* Disabled */
    disabled: {
      border: "#666",
      bg: "#e5e5e5",
      text: "#666",
      input: "#b3b3b3",
      icon: "#666"
    },
    /* Focus */
    focus: {
      indicator: "#2c4e53",
      "indicator-negative": "#c42a2a"
    },
    /* Proficiency */
    proficiency: {
      "highly-proficient-bg": "#5c9fc6",
      "highly-proficient-border": "#5c9fc6",
      "proficient-bg": "#bad5e4",
      "proficient-border": "#5c9fc6",
      "inconsistantly-proficient-bg": "#fff1dc",
      "inconsistantly-proficient-border": "#ea9619",
      "partially-proficient-bg": "#ffd99f",
      "partially-proficient-border": "#ea9619",
      "not-yet-proficient-bg": "#ea9619",
      "not-yet-proficient-border": "#ea9619"
    }
  }
};
var colors = {
  inherit: "inherit",
  current: "currentColor",
  transparent: "transparent",
  atomic,
  // Brand colors
  pr: {
    10: "#E9F7FB",
    20: "#DAF3F6",
    40: "#BFE6EB",
    60: "#ABD5D8",
    80: "#A0C5C2",
    100: "#96B5AD",
    120: "#7CA3A1",
    140: "#649295",
    base: "#407177",
    170: "#355F64",
    180: "#2C4E53"
    /* previous primary.180 color */
  },
  beige: {
    20: "#FAFBF9",
    40: "#F6F7F3",
    60: "#F2F4ED",
    80: "#EEF0E7",
    100: "#EAEDE1",
    120: "#DDDFCA",
    140: "#C4C2AA",
    160: "#9D9880",
    180: "#706C5C"
  },
  khaki: {
    20: "#FCFBF8",
    40: "#F6F3EA",
    60: "#EEE8D5",
    80: "#E8E1C7",
    100: "#E3DABA",
    120: "#D3C491",
    140: "#C4B069",
    160: "#A38E44",
    180: "#877329"
  },
  olive: {
    20: "#EBF5CD",
    40: "#D9EBA0",
    60: "#C7E07D",
    80: "#BFD374",
    100: "#B7C378",
    120: "#A4B366",
    140: "#7F8F4A",
    160: "#606D37",
    180: "#424D25"
  },
  terracotta: {
    20: "#FFECDB",
    40: "#FFC898",
    60: "#FFB474",
    80: "#F1985A",
    100: "#E4844F",
    120: "#D16D37",
    140: "#C05920",
    160: "#9C4719",
    180: "#793714"
  },
  // Neutral colors
  n: {
    "01": "#FCFCFC",
    "04": "#F5F5F5",
    10: "#E5E5E5",
    20: "#CCCCCC",
    30: "#B3B3B3",
    40: "#999999",
    50: "#7F7F7F",
    60: "#666666",
    80: "#333333",
    85: "#252525",
    90: "#181818",
    100: "#000000",
    white: "#FFFFFF"
  },
  // Neutral Alpha colors
  neutralAlpha: {
    n100Alpha40: "rgba(0, 0, 0, 0.4)",
    n100Alpha15: "rgba(0, 0, 0, 0.15)",
    whiteAlpha40: "rgba(255, 255, 255, 0.4)",
    whiteAlpha15: "rgba(255, 255, 255, 0.15)"
  },
  // Curriculum colors
  em1: {
    20: "#DBEECD",
    40: "#B9E29C",
    base: "#7EBB52",
    60: "#498A28",
    80: "#1A661A"
  },
  em2: {
    20: "#FCDECF",
    40: "#F78C64",
    base: "#FF5B35",
    60: "#E65427",
    80: "#D93D1A"
  },
  phD: {
    20: "#E7DBF0",
    40: "#B798CD",
    base: "#845AA2",
    60: "#724494",
    80: "#65328A"
  },
  witWisdom: {
    20: "#D1EBFA",
    40: "#8FCFF3",
    base: "#7CC7F1",
    60: "#64B8E9",
    80: "#46A6DE"
  },
  planning: {
    primary: {
      base: "#853A5F"
    },
    artsAndLetters: {
      base: "#008AB6",
      10: "#DFECF3",
      60: "#478394",
      100: "#055871"
    }
  },
  // Status colors
  status: {
    error: {
      20: "#EECFCF",
      100: "#C42A2A",
      120: "#AD2323",
      140: "#891E1E"
    },
    warning: {
      20: "#F7ECC9",
      100: "#E07000"
    },
    success: {
      20: "#D6F6E3",
      100: "#018939"
    }
  },
  // Auxiliar colors
  aux: {
    pBlue: {
      100: "#CAE4F3",
      200: "#9ED4FF"
    },
    pOrange: {
      100: "#FFD4A6",
      200: "#FF9A48"
    },
    pYellow: {
      100: "#FAEC8F",
      200: "#F9CD19"
    },
    pGreen: {
      100: "#BEF3B3",
      200: "#7DE071"
    },
    pPurple: {
      100: "#D6C8FF",
      200: "#C37EDA"
    }
  },
  // Highlight colors
  highlight: {
    yellow: "#FADE7D",
    pink: "#F6C5D3",
    green: "#DCE9A8",
    blue: "#C7E5EA"
  }
};
var spacing = {
  zero: "0px",
  xxxSmall: "0.125rem",
  // 2px
  xxSmall: "0.25rem",
  // 4px
  xSmall: "0.5rem",
  // 8px
  small: "0.75rem",
  // 12px
  medium: "1rem",
  // 16px
  large: "1.5rem",
  // 24px
  xLarge: "2rem",
  // 32px
  xxLarge: "3rem",
  // 48px
  xxxLarge: "3.5rem",
  // 56px
  xxxxLarge: "5rem"
  // 80px
};
var borderRadius = {
  none: "0",
  small: "0.125rem",
  // 2px
  medium: "0.25rem",
  // 4px
  large: "1rem",
  // 16px
  xLarge: "3.5rem",
  // 56px
  circle: "25rem"
  // 400px
};
var fontFamily = {
  primary: "Circular Std",
  studentExp: "Circular Std",
  teacherExp: "Circular Std",
  fontSans: "Circular Std"
};
var fontSize = {
  rootFontSize: "16px",
  extraSmall: "0.75rem",
  // 12px
  small: "0.875rem",
  // 14px
  medium: "1rem",
  // 16px
  large: "1.125rem",
  // 18px
  extraLarge: "1.375rem",
  // 22px
  extraExtraLarge: "1.625rem",
  // 26px
  huge: "2.25rem",
  // 36px
  extraHuge: "3.25rem",
  // 52px
  extraExtraHuge: "3.5rem"
  // 56px
};
var fontWeight = {
  regular: "400",
  medium: "500",
  bold: "700",
  black: "900"
};
var typography = {
  headings: {
    h1: "1rem",
    // 16px
    h2: "1.375rem",
    // 22px
    h3: "1.125rem",
    // 18px
    h4: "0.875rem"
    // 14px
  },
  titles: {
    huge: "3.5rem",
    // 56px
    page: "2.75rem",
    // 44px
    main: "2.25rem",
    // 36px
    subtitle: "1.625rem",
    // 26px
    minor: "0.75rem"
    // 12px
  },
  textStyles: {
    textBase: "1rem",
    // 16px
    textSmall: "0.875rem",
    // 14px
    textLink: "0.875rem"
    // 14px
  }
};
var boxShadow = {
  "elevation-inset": "inset 0px 0px 2px rgba(0, 0, 0, 0.06), inset 0px -2px 4px rgba(96, 96, 108, 0.1)",
  // Pending use.
  "elevation-1": "0px 0px 2px rgba(0, 0, 0, 0.04), 0px 2px 2px rgba(96, 96, 108, 0.04)",
  // Used on e.g on Floating Button
  "elevation-2": "0px 0px 2px rgba(0, 0, 0, 0.04), 0px 2px 4px rgba(96, 96, 108, 0.1)",
  // Used on e.g on Toolbox Open, Tooltip.
  "elevation-3": "0px 2px 4px rgba(0, 0, 0, 0.04), 0px 4px 6px rgba(96, 96, 108, 0.1)",
  // Used on e.g on Notification Toast.
  "elevation-4": "0px 2px 4px rgba(0, 0, 0, 0.04), 0px 6px 8px rgba(96, 96, 108, 0.12)",
  // Used on e.g on Listbox, Menu List, Overflow Menu.
  "elevation-5": "0px 2px 4px rgba(0, 0, 0, 0.04), 0px 8px 12px rgba(96, 96, 108, 0.16)",
  // Used on e.g on Popover.
  "elevation-6": "0px 2px 4px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(96, 96, 108, 0.24)",
  // Used on e.g on Modals.
  "elevation-7": "0px 10px 16px 0px rgba(14, 25, 27, 0.24), 0px 2px 4px 0px rgba(14, 25, 27, 0.08)",
  "elevation-0": "none"
};
var baseThemeTailwindcss = {
  theme: {
    // Overwrites Tailwind Classes.
    screens,
    fontFamily,
    colors,
    extend: {
      // Extends Tailwind Classes (preserve the default values for a theme option but also add new values).
      spacing,
      borderRadius,
      fontSize,
      fontWeight,
      typography,
      boxShadow
    }
  }
};
var BaseThemeTailwindCSS = _typeof(baseThemeTailwindcss);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BaseThemeTailwindCSS,
  baseThemeTailwindcss
});
//# sourceMappingURL=baseThemeTailwindcss.js.map